import Phaser from 'phaser';

export default class BalloonString extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,startx, starty) {
    super(scene);

    this.gravity = 30;
    this.friction = 0.94;
    this.spring = 0.9;
    this.joins = 12;
    this.distance = 0.6;

    this.rope = null;

    this.baseX = 0;
    this.baseY = 0;

    this.px = [];
    this.py = [];
    this.oldx = [];
    this.oldy = [];
    this.ax = [];
    this.ay = [];

    this.createRope(startx, starty);
    this.add(this.rope);
  }

  createRope (x,y) {
    this.rope = this.scene.add.graphics();
    for (let i = 0; i < this.joins; i++) {
      this.px.push(x);
      this.py.push(y);
      this.oldx.push(x);
      this.oldy.push(y);
      this.ax.push(0);
      this.ay.push(0);
    }
  }

  resetRopePosition (x,y) {
    for (let i = 0; i < this.joins; i++) {
      this.px[i] = x;
      this.py[i] = y + (i * 2) + ((i + 1) * this.distance);
      this.oldx[i] = x;
      this.oldy[i] = y + (i * 2) + ((i + 1) * this.distance);
      this.ax[i] = 0;
      this.ay[i] = 0;
    }
  }

  tick (deltaSeconds,x,y) {
    const d = deltaSeconds;
    this.applyForces(d);
    this.applyFriction();
    this.applyTension();

    this.px[0] = x;
    this.py[0] = y;

    const g = this.rope;
    this.rope.clear();
    this.rope.lineStyle(2, 0x4d4d4d);
    g.moveTo(this.px[0], this.py[0]);
    g.beginPath();

    let force = 0;
    for (let i = 0; i < this.joins; i++) {
      force = Math.sqrt(this.ax[i] * this.ax[i] + this.ay[i] + this.ay[i]);

      g.lineTo(this.px[i], this.py[i]);
    }
    g.strokePath();
  }

  applyForces (d) {
    for (let i = 1; i < this.joins; i++) {
      this.py[i] += this.gravity * d;
    }
  }

  applyFriction () {
    for (let i = 1; i < this.joins; i++) {
      const prevx = this.px[i];
      const prevy = this.py[i];

      this.px[i] += (this.px[i] - this.oldx[i]) * this.friction;
      this.py[i] += (this.py[i] - this.oldy[i]) * this.spring;

      this.oldx[i] = prevx;
      this.oldy[i] = prevy;
    }
  }

  applyTension () {
    const joinDistance = this.distance / this.joins;
    let dx = 0; let dy = 0; let d = 0; let force = 0;
    for (let i = 1; i < this.joins; i++) {
      dx = (this.px[i] - this.px[i - 1]) / 100;
      dy = (this.py[i] - this.py[i - 1]) / 100;
      d = Math.sqrt((dx * dx) + (dy * dy));
      force = d - joinDistance;
      this.ax[i] = (dx / d) * 0.5 * 100 * force;
      this.ay[i] = (dy / d) * 0.5 * 100 * force;
      this.px[i] -= this.ax[i];
      this.py[i] -= this.ay[i];
      this.px[i - 1] += this.ax[i];
      this.py[i - 1] += this.ay[i];
    }
  }
}